
//统计
export default [
    {
        path: 'statistics',
        name: 'statistics',
        alias: '',
        meta: {
            title: '统计',
            icon: 'statistics'
        },
        hidden: false,
        // component: () => import("@/views/statistics/platformSide.vue")
        component: () => import("@/views/statistics/middleground.vue")
    }

]